// "TikTok", "TikTok or YouTube", "Twitch, TikTok or YouTube". No Oxford comma, matching the phrasing
// already used by the platform requirement modal, which this replaced the hand-rolled copy of.
export const joinWithOr = (labels) => {
    var _a;
    if (labels.length <= 1) {
        return (_a = labels[0]) !== null && _a !== void 0 ? _a : '';
    }
    return `${labels.slice(0, -1).join(', ')} or ${labels[labels.length - 1]}`;
};
